import { atom } from 'jotai';
import { LzTNavItems } from '@lz-layouts/Navigation/types';

/**
 * Navigation items for the app.
 * This can be used as a top menus navigation or side-nav menus.
 * For mobile, we can use this same nav items to build the side-nav using the menu 
 * icon based navigation dropper. While the navigation tabs can be built using the
 * code from within the templates, as required.
 */
const lzSLayoutNavItemsAtom = atom<LzTNavItems>([]);

export default lzSLayoutNavItemsAtom;
